import type { FC } from 'react';
import { useEffect } from 'react';

import { LocalActivityAction } from '@confluence/legacy-schema-bridge/entry-points/useLocalActivityCache.ts';

import { useLocalActivityTracker } from './useLocalActivityTracker.ts';

export const LocalActivityViewPageTracker: FC<{ contentId: string }> = ({ contentId }) => {
	useLocalActivityViewPageTracker(contentId);
	return null;
};

const useLocalActivityViewPageTracker = (contentId: string) => {
	const { track } = useLocalActivityTracker();
	useEffect(() => {
		track(contentId, LocalActivityAction.viewed);
	}, [track, contentId]);
};
